<template>
  <div style="display: flex; justify-content: space-between">
    <div class="yuan">
      <div class="shang">
        <svg class="icon" aria-hidden="true" @mousedown.self="operation(0)"
        @mouseup.self="stop(0)">
          <use
            xlink:href="#icon-fangxiangjian-shang"
          ></use>
        </svg>
      </div>
      <div class="zhong">
        <svg class="icon" aria-hidden="true" @mousedown.self="operation(2)"
        @mouseup="stop( 2)">
          <use
            xlink:href="#icon-fangxiangjian-zuo"
          ></use>
        </svg>
        <svg class="icon" aria-hidden="true" @mousedown.self="operation(3)"
        @mouseup.self="stop( 3)">
          <use
            xlink:href="#icon-fangxiangjian-shang-copy"
          ></use>
        </svg>
      </div>
      <div class="xia">
        <svg class="icon" aria-hidden="true" @mousedown.self="operation(1)"
        @mouseup.self="stop( 1)">
          <use
            xlink:href="#icon-fangxiangjian-shang1"
          ></use>
        </svg>
      </div>
    </div>
    <div class="tiao">
      <svg class="icon" aria-hidden="true" @mousedown.self="operation(8)"
      @mouseup.self="stop(8)">
        <use
          xlink:href="#icon-jiahao"
        ></use>
      </svg>
      <svg class="icon" aria-hidden="true" @mousedown.self="operation(9)"
      @mouseup.self="stop(9)">
        <use
          xlink:href="#icon-jianhaocu"
        ></use>
      </svg>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { getToken } from '@/api/video-monitor/video-monitor';

export default {
  data() {
    return {
      token: '',
      parameter: 0,
      dirid: 0,
    };
  },
  props: {
    deviceSerial: String,
    channelNo: Number,
  },
  created() {
    getToken()
      .then((res) => {
        console.log(res);
        this.token = res;
        console.log(this.token);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    operation(parameter) {
      this.dirid = parameter;
      axios
        .post('https://open.ys7.com/api/lapp/device/ptz/start', null, {
          params: {
            accessToken: this.token,
            deviceSerial: this.deviceSerial,
            channelNo: this.channelNo,
            direction: this.dirid,
            speed: 1,
          },
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    stop(parameter) {
      this.dirid = parameter;
      axios
        .post('https://open.ys7.com/api/lapp/device/ptz/stop', null, {
          params: {
            accessToken: this.token,
            deviceSerial: this.deviceSerial,
            channelNo: this.channelNo,
            direction: this.dirid,
            speed: 1,
          },
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.yuan {
  width: 9rem;
  height: 9rem;
  background: rgb(218, 218, 218);
  border-radius: 50%;
  position: absolute;
  left: 1.5rem;
  bottom: 5%;
  display: flex;
  flex-direction: column;
}
.tiao {
  width: 3rem;
  height: 9rem;
  background: rgb(219, 219, 219);
  position: absolute;
  left: 11rem;
  bottom: 5%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.icon {
  width: 2em;
  height: 2em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.shang {
  height: 33.3%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.xia {
  height: 33.3%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.zhong {
  height: 33.3%;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
</style>
